@if (label()) {
    <form-label
        [id]="id() + '-label'"
        [forId]="id() + '-input-number'"
        [label]="label()"
        [required]="required()"
        [tooltipText]="tooltipText()"
        [hasError]="(control().errors && (control().dirty || control().touched)) || showError()">
    </form-label>
}

<p-inputnumber
    [inputId]="id() + '-input-number'"
    [formControl]="control()"
    [showButtons]="showButtons()"
    [buttonLayout]="buttonLayout()"
    [step]="step()"
    [min]="min()"
    [max]="max()"
    [mode]="'decimal'"
    [allowEmpty]="true"
    [fluid]="true"
    [placeholder]="placeholder() | translate"
    (onInput)="onInput.emit()">
    <ng-template #incrementbuttonicon>
        <span class="pi pi-plus"></span>
    </ng-template>
    <ng-template #decrementbuttonicon>
        <span class="pi pi-minus"></span>
    </ng-template>
</p-inputnumber>

@if (control().invalid && (control().dirty || control().touched)) {
    @for (error of getErrorKeys(control().errors); track error) {
        <form-error [text]="getErrorMessage(error)"></form-error>
    }
}
